<template>
  <div
    class="modal fade"
    :ref="`modal-add-product-in-apartment`"
    data-keyboard="false"
    data-backdrop="static"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            {{ $t("serviceAndProductInApartment.addServiceInApartment") }}
          </h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group required">
                <label class="control-label required" for="">{{
                  $t("service.serviceList.serviceName")
                }}</label>
                <v-select
                  class="clear"
                  :options="serviceList"
                  :reduce="data => data.id"
                  :getOptionLabel="option => $t(option.serviceName)"
                  v-model="serviceInApartmentData.serviceId"
                  :placeholder="$t('service.serviceList.serviceName')"
                  @option:selected="
                    onChangeService(serviceInApartmentData.serviceId)
                  "
                >
                  <template v-slot:option="option">
                    {{ option.serviceName }}
                  </template>
                </v-select>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="">{{ $t("service.serviceAttribute") }}</label>
                <v-select
                  class="clear"
                  :options="serviceAttributeList"
                  :reduce="data => data.id"
                  :getOptionLabel="option => $t(option.serviceAttributeType)"
                  v-model="serviceInApartmentData.serviceAttribute"
                  :placeholder="$t('service.serviceAttribute')"
                  @option:selected="
                    onChangeServiceAttribute(
                      serviceInApartmentData.serviceAttribute
                    )
                  "
                >
                  <template v-slot:option="option">
                    {{ $t(option.serviceAttributeType) }}
                  </template>
                </v-select>
              </div>
            </div>
            <div
              class="col-md-12"
              v-if="serviceInApartmentData.serviceAttribute"
            >
              <div class="form-group">
                <label for="">{{ $t("service.service_type") }}: </label>
                <span for="">{{ $t(serviceAttributeData.type) }}</span>
              </div>
              <div class="form-group">
                <label for="">{{ $t("service.serviceUnit") }}: </label>
                <span for="">{{ serviceAttributeData.unit }}</span>
              </div>
              <div class="form-group">
                <label for="">{{ $t("service.service_price") }}: </label>
                <span for="">{{ serviceAttributeData.price }}</span>
              </div>
            </div>
            <div
              class="col-md-12"
              v-if="serviceInApartmentData.serviceAttribute"
            >
              <div class="form-group">
                <label for="">{{
                  $t("serviceAndProductInApartment.quantity")
                }}</label>
                <input
                  type="number"
                  v-model="serviceInApartmentData.serviceAmount"
                  class="form-control"
                  @input="
                    onChangeServiceAmount(serviceInApartmentData.serviceAmount)
                  "
                />
              </div>
            </div>
            <div
              class="col-md-12"
              v-if="serviceInApartmentData.serviceAttribute"
            >
              <div class="form-group">
                <label for="">{{
                  $t("serviceAndProductInApartment.totalFee")
                }}</label>
                <span class="form-control product-info">{{
                  currencyFormat(serviceInApartmentData.totalPrice)
                }}</span>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="">{{
                  $t("serviceAndProductInApartment.startTime")
                }}</label>
                <date-picker
                  class="form-control"
                  v-model="serviceInApartmentData.startTime"
                  :config="options"
                  :placeholder="$t('DD/MM/YYYY')"
                ></date-picker>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="">{{
                  $t("serviceAndProductInApartment.endTime")
                }}</label>
                <date-picker
                  class="form-control"
                  v-model="serviceInApartmentData.endTime"
                  :config="options"
                  :placeholder="$t('DD/MM/YYYY')"
                ></date-picker>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            style="background-color: #f29911;border-color: #f29911;color:#fff"
            type="button"
            class="btn btn-default pull-left"
            data-dismiss="modal"
          >
            {{ $t("common.back") }}
          </button>
          <button type="button" class="btn btn-primary" @click="onSave">
            {{ $t("common.save") }}
          </button>
        </div>
      </div>
    </div>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
  </div>
</template>
<script>
import utils from "@/lib/utils";
// import Enum from "../../../enum/enum";
import { mapActions, mapGetters } from "vuex";
import constantsData from "@/lib/constantsData";
import datePicker from "vue-bootstrap-datetimepicker";
import LTECoreAlert from "@/components/LTESnackBar.vue";

export default {
  components: {
    "date-picker": datePicker,
    "lte-core-alert": LTECoreAlert
  },
  props: {
    bookingId: {
      type: Number,
      default: () => {
        return null;
      }
    }
  },
  data: () => ({
    serviceList: [],
    serviceAttributeList: [],
    serviceInApartmentData: {
      id: 0,
      serviceId: null,
      serviceAttribute: null,
      serviceAmount: null,
      totalPrice: null,
      startTime: null,
      endTime: null
    },
    serviceAttributeData: {
      type: null,
      unit: null,
      price: null
    },
    serviceAttributeTypeList: constantsData.serviceAttributeTypeList,
    options: {
      format: "DD/MM/YYYY",
      useCurrent: false
    },
    apartmentId: null
  }),
  watch: {
    GET_SERVICE_LIST_V2_NO_PAGE_DATA: function() {
      let data = this.GET_SERVICE_LIST_V2_NO_PAGE_DATA;
      this.serviceList = [];
      data.forEach((value, index) => {
        let item = {
          id: value.id,
          serviceCode: value.servicecode,
          serviceName: value.name,
          // productGroupName: '',
          serviceGroup: value.service_group,
          // productUnitName: '',
          // serviceUnit: value.service_unit,
          serviceDescription: value.description,
          serviceType: value.type
        };
        this.serviceList.push(item);
      });
    },
    GET_SERVICE_ATTRIBUTE_LIST_DATA: function() {
      let data = this.GET_SERVICE_ATTRIBUTE_LIST_DATA;
      this.serviceAttributeList = [];
      data.forEach((value, index) => {
        let item = {
          nonumber: index + 1,
          id: value.id,
          serviceAttributeType: this.getServiceAttributeName(value.type),
          times: value.value,
          serviceUnitName: value.service_unit.name,
          serviceUnit: value.service_unit.id,
          servicePrice: value.fee_value
        };
        this.serviceAttributeList.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_SERVICE_LIST_V2_NO_PAGE_DATA",
      "GET_SERVICE_ATTRIBUTE_LIST_DATA",
      "GET_SNACK_BAR"
    ])
  },
  methods: {
    currencyFormat: function(value) {
      if (!utils.isEmptyString(value)) {
        return utils.formatNumber(value);
      }
      return null;
    },
    onShowAddNew: function(apartmentId) {
      $(this.$refs[`modal-add-product-in-apartment`]).modal("show");
      this.apartmentId = apartmentId;
      this.serviceInApartmentData = {
        id: 0,
        serviceId: null,
        serviceAttribute: null,
        serviceAmount: null,
        totalPrice: null,
        startTime: null,
        endTime: null
      };
    },
    onShowDetail: function(data) {
      $(this.$refs[`modal-add-product-in-apartment`]).modal("show");
    },
    onCloseModal: function() {
      $(this.$refs[`modal-add-product-in-apartment`]).modal("hide");
    },
    onSave: async function() {
      if (utils.isEmptyString(this.apartmentId)) {
        this.showError(this.$t("feedback.apartmentCode"));
      } else if (utils.isEmptyString(this.serviceInApartmentData.serviceId)) {
        this.showError(this.$t("service.serviceList.serviceName"));
      } else if (utils.isEmptyString(this.serviceInApartmentData.serviceAttribute)) {
        this.showError(this.$t("service.serviceAttribute"));
      } else if (utils.isEmptyString(this.serviceInApartmentData.serviceAmount)) {
        this.showError(this.$t("serviceAndProductInApartment.quantity"));
      } else if (utils.isEmptyString(this.serviceInApartmentData.startTime)) {
        this.showError(this.$t("serviceAndProductInApartment.startTime"));
      } else if (utils.isEmptyString(this.serviceInApartmentData.endTime)) {
        this.showError(this.$t("serviceAndProductInApartment.endTime"));
      } else {
        let data = {
          id: this.serviceInApartmentData.id,
          apartment: this.apartmentId,
          service: this.serviceInApartmentData.serviceId,
          service_attribute: this.serviceInApartmentData.serviceAttribute,
          unit_price: this.serviceAttributeData.price,
          amount: this.serviceInApartmentData.serviceAmount,
          total_price: this.serviceInApartmentData.totalPrice,
          start_time: utils.formatSqlUtcDate(this.serviceInApartmentData.startTime, "YYYY/MM/DD", "YYYY-MM-DD HH:mm:ss"),
          end_time: utils.formatSqlUtcDate(this.serviceInApartmentData.endTime, "YYYY/MM/DD", "YYYY-MM-DD HH:mm:ss"),
          apartment_booking: this.bookingId
        };
        if (this.serviceInApartmentData.id === 0) {
          this.CREATE_SERVICE_IN_APARTMENT(data)
            .then(
              function() {
                this.onCloseModal();
                this.$emit("callbackGetServiceInApartment");
              }.bind(this)
            )
            .catch(
              function(error) {
                this.ON_SHOW_TOAST({
                  message: error.response.data.message,
                  styleType: "danger"
                });
              }.bind(this)
            );
        }
      }
    },
    showError: function(mess) {
      this.ON_SHOW_TOAST({
        message: mess,
        styleType: "danger"
      });
    },
    onChangeService: function(value) {
      this.getServiceAttrubuteList(value);
    },
    getServiceAttrubuteList: function(serviceId) {
      if (serviceId) {
        let filter = {
          params: {
            serviceId: serviceId
          }
        };
        this.GET_SERVICE_ATTRIBUTE_LIST(filter);
        this.serviceInApartmentData.serviceAttribute = null;
      }
    },
    onChangeServiceAttribute: function(value) {
      let serviceAttribute = this.serviceAttributeList.find(
        x => x.id === value
      );
      this.serviceAttributeData = {
        type: serviceAttribute.serviceAttributeType,
        unit: serviceAttribute.serviceUnitName,
        price: serviceAttribute.servicePrice
      };
    },
    getServiceAttributeName: function(value) {
      let results = "";
      let index = this.serviceAttributeTypeList.findIndex(
        x => x.value === value
      );
      results = index != -1 ? this.serviceAttributeTypeList[index].text : "";
      return results;
    },
    onChangeServiceAmount: function(data) {
      if (utils.isEmptyString(data) || data <= 0) {
        this.showError(this.$t("serviceAndProductInApartment.quantity"));
      } else {
        this.serviceInApartmentData.totalPrice =
          this.serviceAttributeData.price *
          this.serviceInApartmentData.serviceAmount;
      }
    },
    ...mapActions([
      "SUCCESS_TOAST",
      "ERROR_TOAST",
      "ON_SHOW_TOAST",
      "CREATE_SERVICE_IN_APARTMENT",
      "GET_SERVICE_ATTRIBUTE_LIST"
    ])
  },
  mounted() {}
};
</script>
<style scoped>
label.required:not(:empty):after,
.field-header.required:after {
  content: " *";
  color: red;
  position: absolute;
  margin-left: 8px;
  top: 0px;
}
.asset-img-class {
  margin: auto;
  width: 100%;
  max-width: 200px;
  max-height: 250px;
  object-fit: contain;
}
.label-text-center {
  padding-bottom: 10px;
}
.remove-asset-img {
  color: #ef5350;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Product/AddServiceInApartment.vue